// The site's own accounts, kept by the tools service (tools/app/passwords.py):
// a password is chosen from a one-time link mailed to the account.

import { getToolsApiBase } from './ocr';

export class AccountError extends Error {
    status: number;

    constructor(message: string, status: number) {
        super(message);
        this.status = status;
    }
}

async function post<T>(path: string, body: unknown): Promise<T> {
    const response = await fetch(`${getToolsApiBase()}${path}`, {
        method: 'POST',
        // The session cookie the service sets on success.
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        let detail = `HTTP ${response.status}`;
        try {
            detail = ((await response.json()) as { detail?: string }).detail ?? detail;
        } catch {
            // Not JSON: the status says enough.
        }
        throw new AccountError(detail, response.status);
    }
    return (await response.json()) as T;
}

/** The address a live link is for: shown, and given to password managers. */
export function linkAccount(token: string): Promise<{ email: string; purpose: 'invite' | 'reset' }> {
    return post('/auth/password/link', { token });
}

/** Sets the password from the link's token; signs the account in. */
export function setPassword(token: string, password: string): Promise<{ signed_in: boolean; email: string }> {
    return post('/auth/password/reset', { token, password });
}

/** Mails a new link, if the address has an account (the answer never says). */
export function requestPasswordLink(email: string): Promise<{ sent: boolean }> {
    return post('/auth/password/forgot', { email });
}
